import { render, staticRenderFns } from "./ApprovalComment.vue?vue&type=template&id=e84b88f4&"
import script from "./ApprovalComment.vue?vue&type=script&lang=js&"
export * from "./ApprovalComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports